import { Routes, Route, Navigate } from "react-router-dom";

import Login from "containers/Login/Login";
import ManageStudent from "containers/ManageStudent/ManageStudent";
import ManageAgent from "containers/ManageAgent/ManageAgent";
import StudentDetailsContainer from "containers/Student/StudentDetailsContainer";
import AgentDetailsContainer from "containers/Agent/AgentDetailsContainer";
import AuthenticatedRoute from "./components/Routes/AuthenticatedRoutes";
import ManageHomeLayout from "./components/Layout/ManageHomeLayout";
import routes from "constants/routes";
import OrderModification from "./containers/OrderManagement/OrderModification";
import OrderCancellation from "./containers/OrderManagement/OrderCancellation";
import NotFoundPage from "components/ErrorBoundary/NotFoundPage";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path={routes.login.root} element={<Login />} />

      <Route element={<AuthenticatedRoute />}>
        <Route element={<ManageHomeLayout />}>
          <Route path={routes.manageStudent.root} element={<ManageStudent />} />
          <Route path={routes.manageAgent.root} element={<ManageAgent />} />
        </Route>
        <Route path={routes.studentDetails} element={<StudentDetailsContainer />} />
        <Route path={routes.agentDetails} element={<AgentDetailsContainer />} />
        <Route path={routes.default} element={<Navigate to={routes.manageStudent.root} replace />} />
        <Route path={routes.modifyOrder} element={<OrderModification />} />
        <Route path={routes.cancelOrder} element={<OrderCancellation />} />
        <Route path={routes.pageNotFound} element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
